import { Component, AfterViewInit, OnInit, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, ActivatedRouteSnapshot, Event, NavigationStart, Router } from '@angular/router';
import { CurrentMenuState, CurrentMenuStateService } from './services/current-menu-state.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { cpDcService } from './services/cp-dc/cp-dc.service';
import { cpmService } from './services/cp-dc/cpm.service';
import { VideoPopupService } from './services/cp-dc/video-popup.service';
import { MusicService } from './services/music.service';
import { ShareService } from './services/share-service.service';
import { AdType } from './components/desktop-ad/desk-ad-type';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: []
})
export class AppComponent implements OnInit {
  isMobileEnv = environment.isMoblie;
  currentState: CurrentMenuState;
  hideAddForFullPage = false;
  hideAddForFooterPage = false;
  openVideoPopUp = false;
  openMuiscPopUp = false;
  openSharePopup = false;
  AdType = AdType;
  videoSub: Subscription;
  musicSub: Subscription;
  shareSub: Subscription;
  currentMenu: Subscription;
  
  constructor(
    private spinn: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private currentMenuStateService: CurrentMenuStateService,
    private cpdcService: cpDcService,
    private cpmService: cpmService,
    private videoPopupService: VideoPopupService,
    private musicService: MusicService,
    private shareService: ShareService
  ) { }

  ngOnInit(): void {
    this.applyCategoryStyles();
    this.setupRouterEvents();
    this.subscribeToMenuState();
    this.callCpDc();
   this.videoSub = this.videoPopupService.openVideoAddModal$.subscribe(res => {
      this.openVideoPopUp = res;
    });
    this.musicSub = this.musicService.openMusicModal$.subscribe(res => {
      this.openMuiscPopUp = res;
    });
    this.shareSub = this.shareService.openSharePopup$.subscribe(res => {
      this.openSharePopup = res;
    });
  }

  callCpDc(): void {
    this.cpdcService.fetchAds().subscribe();
    this.cpmService.fetchAds().subscribe();
  }
  

  private setupRouterEvents(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.handleNavigationEnd();
      }
    });
  }

  private timeoutId: any; // Define a property to store the timer ID

  private handleNavigationEnd(): void {
    const urlSegments = this.router.url.split('/').filter(part => !!part);
    this.hideAddForFullPage = false;
    this.hideAddForFooterPage = false;

    clearTimeout(this.timeoutId);
  
    this.timeoutId = setTimeout(() => {
      this.hideAddForFullPage = this.shouldHideAdsForFullPage(urlSegments) ? false : true;
      if ((urlSegments.filter(segment => segment === 'search').length == 1)) {
        this.hideAddForFooterPage = false;
      } else {
        this.hideAddForFooterPage = true;
      }

      const nodeList = document.querySelectorAll(".ut_container");
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].remove()
      }
    }, 400); // Adjust the delay time (in milliseconds) as per your requirement
  }

  private shouldHideAdsForFullPage(urlSegments: string[]): boolean {
    return (
      urlSegments.filter(segment => segment === 'all').length === 2 ||
      urlSegments.length === 0 ||
      urlSegments.filter(segment => segment === 'search').length == 1
      || urlSegments.filter(segment => segment === 'videos').length == 1
    );
  }



  private subscribeToMenuState(): void {
   this.currentMenu =  this.currentMenuStateService.currentState$.subscribe((state: CurrentMenuState) => {
      this.currentState = state;
    });
  }

  ngDestroy(): void {
    this.videoSub.unsubscribe();
    this.musicSub.unsubscribe();
    this.shareSub.unsubscribe();
    this.currentMenu.unsubscribe();
  }

    // Method to dynamically update CSS variables
    updateStyles(styles: { [key: string]: string }) {
      Object.keys(styles).forEach((key) => {
        this.renderer.setStyle(
          document.documentElement,
          `--${key}`,
          styles[key],
          2 // This adds !important to the style
        );
      });
    }
  
    // Define different category styles #eaebeb
    nightlifeTelivision = {
      titlebar: '#000',
      titlebargrad: 'rgb(66, 63, 63)',
      menubar: '#000',
      menuborder: '#ccc',
      weather: '#f0f1f1',
      pagetitle: '#03bdd6',
      pagetitlegrad: '#2b69db',
      btnclr: '#0edc5d',
      logoback: '#000',
      topicons: '#009788',
      linkcolor: '#007bff'
    };
  
    dotnet = {
      titlebar: '#2b95d6',
      titlebargrad: '#187ab7',
      menubar: '#2488c6',
      menuborder: '#69bcfd',
      weather: 'grey',
      pagetitle: '#0ca20c',
      pagetitlegrad: '#000',
      btnclr: '#ff7764',
      logoback: '#fff',
      topicons: '#009788',
      linkcolor: '#007bff'
    };
  
    musicLand = {
      titlebar: '#0e0021',
      titlebargrad: '#594c6b',
      menubar: '#0e0021',
      menuborder: '#69bcfd',
      weather: '#eaebeb',
      pagetitle: '#838889',
      pagetitlegrad: '#000',
      btnclr: '#ff7764',
      logoback: '#fff',
      topicons: '#009788',
      linkcolor: '#007bff',
      logoback1: '#000',
    };
  
    hollywood = {
      titlebar: '#b71b1b',
      titlebargrad: '#cf6767',
      menubar: '#b71b1b',
      menuborder: '#69bcfd',
      weather: '#eaebeb',
      pagetitle: '#00bcd5',
      pagetitlegrad: '#000',
      btnclr: '#ff7764',
      logoback: '#b71b1b',
      topicons: '#009788',
      linkcolor: '#007bff'
    };
  
    // Method to apply the styles based on the selected category
    applyCategoryStyles() {
      if (environment.environmentType === 'n') {
        this.updateStyles(this.nightlifeTelivision);
      } else if (environment.environmentType === 'd') {
        this.updateStyles(this.dotnet);
      } else if (environment.environmentType === 'm') {
        this.updateStyles(this.musicLand);
      } else if (environment.environmentType === 'h') {
        this.updateStyles(this.hollywood);
      }
    }
  
}